import { useMutation } from "react-query";
import http from 'infra/http';

function useAnalisarAnuncio() {
  return useMutation(
    `/v1/anuncio/analisar`,
    async (id: string) => {
      const { data } = await http.post<{success: boolean}>(
        `/v1/anuncio/${id}/analisar`,
      );

      return data;
    },
    { retry: false }
  );
}

export default useAnalisarAnuncio;
